<template>
  <div class="card contact-card mb-3">
    <div class="card-up contact-bg"></div>
    <div class="avatar mx-auto bg-white">
      <div class="rounded-circle letters align-middle">
        {{ getInitials(Contact.firstName + " " + Contact.lastName) }}
      </div>
    </div>
    <div class="card-body">
      <b class="mb-4">{{ Contact.firstName + " " + Contact.lastName }}</b>
      <hr />
      <div class="mt-1">
        <i v-if="Contact.internalEmailAddress" class="bi bi-envelope-at"></i>
        <div v-if="Contact.internalEmailAddress">
          <a :href="'mailto:' + Contact.internalEmailAddress">{{
            Contact.internalEmailAddress
          }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { BioGaiaContact } from "@/data/client";
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({})
class ContactCard extends Vue {
  @Prop({ default: null })
  Contact!: BioGaiaContact;

  getInitials(fullName: string): string {
    const names = fullName.split(" ");
    const firstName = names[0];
    const lastName = names[names.length - 1];
    return `${firstName.charAt(0)}${lastName.charAt(0)}`;
  }
}
export default ContactCard;
</script>
